module.exports = __webpack_public_path__ + "static/media/offlineWaterFilling.5a0d135c.svg";